import {useCookie} from "../model/useCookie";
import {Link} from "@/shared/ui/Link";
import {Button} from "@/shared/ui/Button";
import styles from "./Cookie.module.scss";

type Props = {
    hideCookie: boolean;
}

export const Cookie = ({hideCookie}: Props) => {
    const cookie = useCookie({hideCookie});

    if (cookie.hide) return null;

    return (
        <div className={styles.container}>
            <p className={styles.title}>Мы используем файлы cookie</p>
            <div className={styles.item}>
                <p className={styles.text}>
                    Мы используем технологию "cookie" - небольшие текстовые файлы, размещаемые на устройстве пользователя
                    для корректной работы нашего сайта. Вы можете отказаться от использования cookie, выбрав соответствующие
                    настройки в браузере. Однако это может повлиять на работу некоторых функций сайта. Продолжая
                    пользоваться нашим сайтом вы соглашаетесь на использование cookie в соответствии с
                </p>
                <Link href={`/politika-konfidencialnosti`} className={styles.link}>
                    &nbsp;Политикой конфиденциальности.
                </Link>
            </div>
            <Button onClick={() => cookie.close()} fullWidth>Хорошо</Button>
        </div>
    );
}
